import React, { useState } from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { copyAddressToClipboard } from "../../../utils/mapNavigation";

function CopyButton({ textToCopy, style }) {
  const [didCopy, setDidCopy] = useState(false);

  const handleCopyAddress = async () => {
    if (!textToCopy) return;
    const copied = await copyAddressToClipboard(textToCopy);
    if (!copied) return;

    setDidCopy(true);
    setTimeout(() => setDidCopy(false), 1800);
  };
  
  return (
    <TouchableOpacity
      onPress={handleCopyAddress}
      activeOpacity={0.85}
      accessibilityRole="button"
      accessibilityLabel={didCopy ? "Address copied" : "Copy address"}
      style={[styles.button, style]}
    >
      <Ionicons
        name={didCopy ? "checkmark" : "copy-outline"}
        size={16}
        color="#6B4C3B"
      />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: "#D6C4B8",
    backgroundColor: "#FFFFFF",
  },
});

export default CopyButton;
